<script setup lang="ts">
import PrintLayout from '@/components/Layouts/PrintLayout.vue'
import DefaultLayout from '@/components/Layouts/DefaultLayout.vue'
import { onBeforeMount, onUnmounted } from 'vue'
import { useMainStore } from '@/stores/MainStore'
import GeneralPopup from '@/components/Shared/GeneralPopup.vue'
import { clearTokenExpirationCheck } from './utils/TokenManager'

const mainStore = useMainStore()

// Validate session before the component is mounted
onBeforeMount(async () => {
  await mainStore.refresh() // Refresh session immediately
  mainStore.addFocusListener() // Add focus listener
})

// Cleanup on unmount
onUnmounted(() => {
  mainStore.removeFocusListener() // Remove focus listener
  clearTokenExpirationCheck() // Clear token expiration handling
})
</script>

<template>
  <PrintLayout v-if="$route.meta.layout === 'print'" />
  <DefaultLayout v-if="$route.meta.layout == null" />
  <GeneralPopup />
</template>
